export default "__VITE_ASSET__RVwdG2ND__"